<template>
    <div id="cause-analysis">
        <a-spin :spinning="spinning">
            <div class="content" v-if="causeAnalysisSelect && !showDetails">
                <a-row v-if="!showSecondData">
                    <a-col
                            class="item-grid"
                            v-for="(item,index) in causeAnalysisSelect"
                            :key="index"
                            :xs="8"
                            :sm="8"
                            :xl="6"
                            :xxl="6"
                    >
                        <a-card hoverable style="width: 100%" @click="onClickDetails(item)">
                            <img
                                    v-if="item.menuCity"
                                    :src="item.menuCity | imgUrl(9)"
                                    slot="cover"
                                    class="item-img"
                            />
                            <img
                                    v-else
                                    :src="item.menuId | imgUrl(1)"
                                    slot="cover"
                                    class="item-img"
                            />
                            <a-card-meta :title="item.title">
                                <template
                                        slot="description"
                                >
                                    <!--{{item.subtitle ? item.subtitle : item.title}}-->
                                </template>
                            </a-card-meta>
                        </a-card>
                        <div class="shadow-box" v-if="item.enabled">
                            <div class="f16">
                                <span v-if="item.enabled === 1">暂无数据</span>
                                <span v-else-if="item.enabled === 2">登录可见</span>
                                <span v-else-if="item.enabled === 3">购买可见</span>
                                <span v-else>升级可见</span>
                            </div>
                        </div>
                    </a-col>
                    <!-- 显示第二级子菜单 -->
                </a-row>
                <template v-else>
                    <a-row
                            v-for="group in showSecondData.children"
                            :key="group.menuId"
                    >
                        <!-- <h2 class="title">{{group.title}}</h2> -->
                        <a-divider class="line" orientation="left">{{group.title}}</a-divider>
                        <a-col
                                class="item-grid"
                                v-for="(item,index) in group.children"
                                :key="index"
                                :xs="8"
                                :sm="8"
                                :xl="6"
                                :xxl="6"
                        >
                            <a-card hoverable style="width: 100%" @click="onClickDetails(item)">
                                <img
                                        :src="imgRootUrl+item.icon"
                                        slot="cover"
                                        class="item-img"
                                />
                                <a-card-meta :title="item.title">
                                    <template
                                            slot="description"
                                    >
                                        <!--{{item.subtitle ? item.subtitle : item.title}}-->
                                    </template>
                                </a-card-meta>
                            </a-card>
                            <div class="shadow-box" v-if="item.enabled">
                                <div class="f16">
                                    <span v-if="item.enabled === 1">暂无数据</span>
                                    <span v-else-if="item.enabled === 2">登录可见</span>
                                    <span v-else-if="item.enabled === 3">购买可见</span>
                                    <span v-else>升级可见</span>
                                </div>
                            </div>
                        </a-col>
                    </a-row>
                </template>
            </div>
            <ResourceDetails
                    v-if="showDetails"
                    :detailsData="detailsData"
            />
        </a-spin>
    </div>
</template>

<script>
    import UrlApi from "@/utils/UrlApi.js";
    import ResourceDetails from "./ResourceDetails";

    export default {
        name: "CauseAnalysis",
        data() {
            return {
                imgRootUrl: UrlApi.imgIconRoot,
                spinning: false,
                causeAnalysisSelect: null
            };
        },
        components: {
            ResourceDetails
        },
        computed: {
            showSecondData() {
                let state = false;
                if (this.$store.getters.getSecondSelectData) {
                    state = this.$store.getters.getSecondSelectData;
                }
                return state;
            },
            showDetails() {
                let state = false;
                if (this.$route.query.detailsId) {
                    state = true;
                }
                return state;
            },
            // causeAnalysisSelect() {
            //     return this.$store.getters.getCauseAnalysisSelect;
            // },
            detailsData() {
                return this.$store.getters.getResourceDetailsData;
            },
            userName() {
                return this.$store.getters.getUserName;
            },
            id: {
                get() {
                    return this.$route.query.id
                }
            },
            DSTTagsList: {
                get() {
                    return this.$store.state.DSTTagsList
                },
                set(val) {
                    this.$store.commit("updateDSTTagsList", val);
                }
            },
            seriousDate: {
                get() {
                    return this.$route.query.seriousDate
                }
            },
            startDate: {
                get() {
                    return this.$route.query.startDate
                }
            },
            endDate: {
                get() {
                    return this.$route.query.endDate
                }
            },
        },
        mounted() {
            this.getData()
        },
        methods: {

            getData(id) {
                let url = UrlApi.cityList;
                let gpsState = this.$store.getters.getGpsState;
                let params = Object.assign({}, gpsState);
                params.userId = this.$store.getters.getUserId;
                let causeParams = Object.assign({}, params);
                causeParams.menuTypeId = id ? id : this.id;

                this.spinning = true
                // console.log(causeParams)
                this.$http.get(url, {
                    params: causeParams
                }).then(res => {
                    this.spinning = false
                    this.causeAnalysisSelect = res.data.data
                })
            },

            onClickDetails(detailsData) {

                if (detailsData.children && detailsData.children.length) {
                    this.$router.push({
                        name: 'CauseAnalysis',
                        query: {id: detailsData.menuId}
                    })
                } else {



                    if(this.seriousDate){
                        this.$router.push({
                            name: 'ResourceDetails',
                            query: {
                                id: detailsData.menuId,
                                seriousDate:this.seriousDate,
                                startDate:this.startDate,
                                endDate:this.endDate,
                            }
                        })

                        return
                    }

                    let data = {
                        url: 'ResourceDetails',
                        name: detailsData.title,
                        query: JSON.stringify({id: detailsData.menuId})
                    }

                    this.handleVOCTagsList(data)
                    this.$router.push({
                        name: 'ResourceDetails',
                        query: {id: detailsData.menuId, synopsis: detailsData.synopsis, title: detailsData.title}
                    })
                }

                // let data = {
                //     url: 'ResourceDetails',
                //     name: detailsData.title,
                //     query: JSON.stringify({id: detailsData.menuId})
                // }
                //
                // this.handleVOCTagsList(data)
                //
                // this.$router.push({
                //     name: 'ResourceDetails',
                //     query: {id: detailsData.menuId, synopsis: detailsData.synopsis, title: detailsData.title}
                // })
                // children有内容继续进入列表
                // if (detailsData.children && detailsData.children.length) {
                //     let {params} = this.$route;
                //     let menuId = params.menuId + "-" + detailsData.menuId;
                //     this.$router.push({name: 'CauseAnalysis', params: {menuId: menuId}});
                //     this.$store.commit("updateSecondSelectData", detailsData.menuId);
                //     return
                // }
                // this.$router.push({name: 'CauseAnalysis', query: {detailsId: detailsData.menuId}});
                // this.$store.commit("updateResourceDetailsData", detailsData.menuId)
            },
            handleVOCTagsList(item) {
                let List = JSON.parse(JSON.stringify(this.DSTTagsList))
                let isExist = false
                for (let i = 0; i < List.length; i++) {
                    if (List[i].url === item.url && List[i].query === item.query) {
                        isExist = true
                    }
                }

                if (!isExist) {
                    List.push(item)
                    this.DSTTagsList = List
                }
            },
        },
        beforeRouteUpdate(to, from, next) {
            // // console.log(to)
            this.getData(to.query.id)
            next();
        },
    }

</script>
<style lang="less" scoped>
    #cause-analysis {
        width: 100%;
        margin: 0 auto;
        min-height: calc(100vh - 106px);
        overflow: auto;
        .line {
            font-size: 22px;
            padding: 0 20px;
            &::before {
                border-top: 1px solid #2F639A;
            }
            &::after {
                border-top: 1px solid #2F639A;
            }
        }
    }

    .item-grid {
        padding: 0 20px;
        margin-top: 30px;
        padding-bottom: 10px;
        position: relative;
        top: 0;
        left: 0;
        .shadow-box {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            padding: 0 20px;
            padding-bottom: 10px;
            div {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(0, 0, 0, .4);
                color: #ffffff;
            }
        }
        .item-img {
            width: 100%;
            height: 200px;
        }
    }
</style>